// Маршруты. Адресная схема настоящая с фазы фундамента: /:section/:view/r/:rowId плюс
// состояние в поисковой строке (?p=… — стопка панелей). Защищённая область живёт в общем
// скелете AppShell: полоса разделов слева, область раздела правее, панели поверх.

import { Navigate, createBrowserRouter } from 'react-router';

import { CrashScreen } from '@/app/CrashScreen';
import { AppShell } from '@/layout/AppShell';
import { SectionScreen } from '@/layout/SectionScreen';
import { LoginPage } from '@/modules/login/LoginPage';
import { RequireAuth } from '@/shared/auth/RequireAuth';
import { startRoute } from '@/shared/auth/start-route';
import { useAuthStore } from '@/shared/auth/store';
import { EmptyState } from '@/shared/ui/screen-state';

/** Открывает стартовый раздел по роли; когда разделов нет вовсе, честно объясняет почему. */
function StartRedirect() {
  const user = useAuthStore((state) => state.user);
  const target = user === null ? null : startRoute(user);
  if (target !== null) {
    return <Navigate to={target} replace />;
  }
  return (
    <main className='flex h-full flex-1 items-center justify-center bg-bg-weak-50'>
      <EmptyState
        title='Разделы не назначены'
        description='Вашей учётной записи не назначен ни один раздел. Попросите администратора выдать права и войдите заново.'
      />
    </main>
  );
}

function NotFoundScreen() {
  return (
    <main className='flex h-full flex-1 items-center justify-center bg-bg-weak-50'>
      <EmptyState
        title='Страница не найдена'
        description='Такого адреса в системе нет. Проверьте ссылку или откройте стартовый экран через полосу разделов слева.'
      />
    </main>
  );
}

// Перехватчик стоит на КАЖДОМ уровне, а не только на корневом. На корневом он заменил бы
// собой всё окно вместе с полосой разделов, и единственным выходом осталась бы перезагрузка;
// на уровне представления полоса разделов остаётся на месте, и человек уходит в соседний
// раздел одним нажатием.
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: <CrashScreen /> },
  {
    element: <RequireAuth />,
    errorElement: <CrashScreen />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/', element: <StartRedirect />, errorElement: <CrashScreen /> },
          { path: '/:section', element: <SectionScreen />, errorElement: <CrashScreen /> },
          { path: '/:section/:view', element: <SectionScreen />, errorElement: <CrashScreen /> },
          {
            path: '/:section/:view/r/:rowId',
            element: <SectionScreen />,
            errorElement: <CrashScreen />,
          },
          { path: '*', element: <NotFoundScreen /> },
        ],
      },
    ],
  },
]);
